import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "trigger"]

  connect() {
    this.setOpen(false)
    this.element.dataset.popperReady = "true"
  }

  disconnect() {
    this.setOpen(false)
    delete this.element.dataset.popperReady
    delete this.element.dataset.popperOpen
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.setOpen(this.panelTarget.style.visibility !== "visible")
  }

  close() {
    this.setOpen(false)
  }

  closeOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  setOpen(open) {
    this.panelTarget.style.visibility = open ? "visible" : "hidden"
    this.panelTarget.setAttribute("aria-hidden", String(!open))
    this.triggerTarget.setAttribute("aria-expanded", String(open))
    this.element.dataset.popperOpen = String(open)
  }
}
